import React from "react";
import Picture from "../Picture";
import { formatImageUrl } from "../../utils";
import { StyledClub, StyledClubName } from "./StyledClub";

const ClubV2 = ({
  clubData,
  isHome,
  hasAbbreviation = false,
  hasFullName = false,
  hasShortName = false,
  className = "",
  rank = null,
}) => {
  const { abbreviation, fullName, shortName, logoColorUrl } = clubData || {};

  if (!abbreviation && !fullName && !shortName) {
    return null;
  }

  const { highQuality } = logoColorUrl
    ? formatImageUrl(logoColorUrl, {
      format: "w_128,h_128,c_pad",
      extension: "f_png",
    })
    : { highQuality: "/assets/images/Fallbacklogo-grey.png" };

  return (
    <StyledClub
      className={`mls-c-club --${isHome ? "home" : "away"} ${className}`}
    >
      <Picture
        className={`mls-c-club__picture`}
        src={highQuality}
        title={fullName || shortName}
        role="presentation"
      />
      <StyledClubName className={`mls-c-club__name`}>
        {hasAbbreviation && (
          <span className="mls-c-club__abbreviation">
            {isHome && rank && (
              <span className="mls-c-club__rank">({rank})</span>
            )}
            {abbreviation}
            {!isHome && rank && (
              <span className="mls-c-club__rank">({rank})</span>
            )}
          </span>
        )}
        {hasFullName && (
          <span className="mls-c-club__fullname">{fullName}</span>
        )}
        {hasShortName && (
          <span className="mls-c-club__shortname">
            {isHome && rank && (
              <span className="mls-c-club__rank">({rank})</span>
            )}
            {shortName}
            {!isHome && rank && (
              <span className="mls-c-club__rank">({rank})</span>
            )}
          </span>
        )}
      </StyledClubName>
    </StyledClub>
  );
};

export default ClubV2;
